module.exports = __webpack_public_path__ + "img/eye.15296a02.svg";